export default {"src":"/_next/static/media/tolstoy.6dddffc0.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};